export default __webpack_public_path__ + "static/media/D_Biscuits.26b9d4c4.svg";